module.exports = __webpack_public_path__ + "mexico.svg?6ee1e6d4e6ac3a5803dea8c482afdaea";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/mexico.svg
// module id = 231
// module chunks = 10